import React from 'react'
import {Link, useLocation} from 'react-router-dom'
import {isMobileDevice} from '../../../_metronic/assets/ts/_utils'
import {useSelector} from 'react-redux'
import './../../common/globalFontSize.css'
const DeviceHeader = (props: any) => {
  const location = useLocation()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  return (
    <>
      {!isMobileDevice() && (
        <div className='card mb-5 '>
          <div className='card-body pt-4 pb-0'>
            <div className='d-flex overflow-auto h-55px dynamic-font-size'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent  fw-bolder flex-nowrap'>
                <li className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname === '/task/as' && 'active')
                    }
                    to='/task/as'
                  >
                    A/S 관리
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname === '/task/recovery' && 'active')
                    }
                    to='/task/recovery'
                  >
                    회수조회
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      {isMobileDevice() && (
        <div className='card mb-5 mb-xl-10 mt-5'>
          <div className='card-body pt-4 pb-0'>
            <div className='d-flex overflow-auto h-auto'>
              {userInfo?.accountType === 'sys_admin' && (
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-bolder justify-content-evenly'
                  style={{fontSize: '20px'}}
                >
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/task/as' && 'active')
                      }
                      to='/task/as'
                    >
                      A/S 관리
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/task/recovery' && 'active')
                      }
                      to='/task/recovery'
                    >
                      회수조회
                    </Link>
                  </li>
                </ul>
              )}
              {userInfo?.accountType === 'sys_user' && (
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-bolder justify-content-evenly'
                  style={{fontSize: '20px'}}
                >
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/task/as' && 'active')
                      }
                      to='/task/as'
                    >
                      A/S 관리
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/task/recovery' && 'active')
                      }
                      to='/task/recovery'
                    >
                      회수조회
                    </Link>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default DeviceHeader
